<template>
  <MediaWord type="image" />
</template>

<script>
import MediaWord from '../components/media/MediaWord.vue'

export default {
  name: 'PictureWord',
  components: { MediaWord }
}
</script>
